import { EntityQuery, FilterQueryOp } from 'breeze-client';
import { Report, ReportCategory } from '../../models';

const baseQuery = EntityQuery.from('Reports');
const reportAccess = baseQuery.expand(Report.propName('allowedPrincipals')).orderBy(Report.propName('name'));
const reportAskAgoraQuery = baseQuery
  .where(Report.propName('category'), FilterQueryOp.StartsWith, ReportCategory.AskAgora)
  .where(Report.propName('isPublished'), FilterQueryOp.Equals, true)
  .select(Report.propNames('id', 'category'))
  .orderBy(Report.propName('category'))
  //to favour custom reports over standard if not hiding
  .orderBy(Report.propName('isCustom'))
  //show only the oldest report if multiple reports in same category
  .orderByDesc(Report.propName('createdDate'));

export const reportQueries = {
  selectAll: baseQuery,
  selectReportAccess: reportAccess,
  selectAskAgora: reportAskAgoraQuery
};
